import { LinkOpenIcon, type TypeTableColumn } from '@thefarmersfront/kitchen';

import { BadgeCell, TextButtonCell } from '~/components/common';

import { formatDate } from '~/utils/date';

import { DATE_FORMAT } from '~/constants';
import { CLAIM_RETURN_COURIER_STATUS_BADGE_COLOR, type TypeClaimReturnCourierStatus } from '~/constants/claim';

import type { TypeReturnDetailData } from '~/types/claim.types';

type TypeReturnOrderTracking = NonNullable<TypeReturnDetailData['returnOrderTrackings']>[number];

/**
 * [반품 신청/조회] 신청 상세 모달 > '회수 송장 정보' 테이블 컬럼 정의
 */
const getClaimReturnDetailTrackingColumnDefs = () => {
  const columnDefs: TypeTableColumn<TypeReturnOrderTracking>[] = [
    {
      id: 'no',
      header: 'No',
      cell: ({ row }) => row.index + 1,
      size: 72,
    },
    {
      accessorKey: 'invoiceNumber',
      header: '회수 송장번호',
      size: 130,
    },
    {
      accessorKey: 'status',
      header: '송장상태',
      size: 100,
      cell: ({ getValue }) => {
        const value = getValue<TypeReturnOrderTracking['status']>();
        if (!value?.code) return '-';
        const code = value.code as TypeClaimReturnCourierStatus;
        return (
          <BadgeCell
            value={code}
            colorMap={{ [code]: { label: value.name, color: CLAIM_RETURN_COURIER_STATUS_BADGE_COLOR[code] } }}
            variant="light"
            status
          />
        );
      },
    },
    {
      accessorKey: 'invoiceTrackingUrl',
      header: '',
      size: 95,
      cell: ({ getValue }) => {
        const url = getValue<string | null | undefined>();
        return (
          <TextButtonCell
            value={url}
            target="_blank"
            href={url ?? undefined}
            rightIcon={<LinkOpenIcon size={16} color="#672091" />}
          >
            배송조회
          </TextButtonCell>
        );
      },
    },
    {
      accessorKey: 'failureReason',
      header: '회수 실패사유',
      minSize: 335,
      meta: { flex: true },
    },
    {
      accessorKey: 'statusAt',
      header: '최종 업데이트일시',
      size: 159,
      cell: ({ getValue }) => formatDate(getValue<string>(), DATE_FORMAT.DATE_TIME) ?? '-',
    },
  ];

  return { columnDefs };
};

export default getClaimReturnDetailTrackingColumnDefs;
